import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import {
  AttendeesLangDescripAndButton,
  ButtonViewDetails,
  ContentDescriptLang,
  EventDateDescription,
  EventTitle,
  SpeakerDescription,
  useStyles,
  ContentImgEvents,
  EventInfo,
  Attendees,
  FullEventInfo,
  ContentFullEventInfo,
} from "./ListCardEvents.styled";
import imgOtherEvent from "../../assets/image-not-available.png";
import { getFile } from "../../services/FileManager";
import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Tooltip } from "@material-ui/core";
import Info from "@material-ui/icons/Info";
import PropTypes from "prop-types";
import Flag from "react-flagkit";
import { CountryName } from "../../hooks/CountryName";
import moment from "moment";

const ListCardEvent = ({
  idEvent,
  eventTitle,
  startDate,
  startTime,
  endTime,
  attendees,
  language,
  urlPhoto,
  createUser,
  description,
  isFull,
  recurrenceEndDate,
  recurrencePattern,
}) => {
  const options = { weekday: "short", month: "short", day: "numeric" };
  const classes = useStyles();
  const [previewImage, setPreviewImage] = useState(imgOtherEvent);
  const history = useHistory();
  const [freqValue] = useState(
    recurrencePattern ? recurrencePattern.match(/FREQ=([^;]+)/)[1] : null
  );

  useEffect(() => {
    if (urlPhoto) {
      getFile(urlPhoto).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setPreviewImage(URL.createObjectURL(response));
        }
      });
    } else {
      setPreviewImage(imgOtherEvent);
    }
  }, [urlPhoto]);

  let handleSeeDetails = (eventId) => {
    history.push({
      pathname: `/DetailEvent`,
      state: { idEvent: eventId, event: {}, path: `/Activities` },
    });
  };

  return (
    <Col md={3} className={classes.containerEvents}>
      {isFull ? (
        <ContentFullEventInfo>
          <FullEventInfo>Closed event</FullEventInfo>
        </ContentFullEventInfo>
      ) : (
        ""
      )}

      <ContentImgEvents>
        <img src={previewImage} className={classes.imgOtherEvent} alt="" />
      </ContentImgEvents>
      <EventInfo>
        <EventTitle>{eventTitle}</EventTitle>
        <SpeakerDescription>
          <b>Created by:</b> {createUser}
        </SpeakerDescription>
        <EventDateDescription hidden={!recurrenceEndDate || !recurrencePattern}>
          <span>
            <b>Recurren Event</b>
            <br />
            <b>Frecuency:</b> Every
          </span>{" "}
          <span className={"freq-text"}>{freqValue}</span>
          <br />
          <span>
            From{" "}
            {new Date(startTime).toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            })}{" "}
            -{" "}
            {new Date(endTime).toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </EventDateDescription>
        <EventDateDescription hidden={recurrenceEndDate || recurrencePattern}>
          <b>Active until:</b> {moment(startDate).format("ddd, MMM DD")} |{" "}
          {new Date(startTime).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </EventDateDescription>
        <Attendees>{attendees} Attendees </Attendees>
        <AttendeesLangDescripAndButton>
          <ContentDescriptLang>
            <Flag
              key={idEvent}
              style={{ borderRadius: "99px" }}
              className="mx-1"
              country={`${
                language === "en"
                  ? "US"
                  : language.toUpperCase()
              }`}
            />
            <CountryName countryCode={language} />
          </ContentDescriptLang>
          <div style={{ display: "flex" }}>
            <Tooltip
              title={
                <div
                  style={{ margin: "20px 0" }}
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                ></div>
              }
            >
              <Info
                style={{ width: "20px", height: "20px", marginRight: "10px" }}
              />
            </Tooltip>
            <ButtonViewDetails
              hidden={isFull}
              className="btn"
              onClick={() => handleSeeDetails(idEvent)}
            >
              <ArrowForwardIcon style={{ fontSize: "1em" }} />
            </ButtonViewDetails>
          </div>
        </AttendeesLangDescripAndButton>
      </EventInfo>
    </Col>
  );
};
export default ListCardEvent;

ListCardEvent.propTypes = {
  idEvent: PropTypes.number,
  eventTitle: PropTypes.string,
  startDate: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  attendees: PropTypes.string,
  language: PropTypes.string,
  urlPhoto: PropTypes.string,
  createUser: PropTypes.string,
  description: PropTypes.string,
  isFull: PropTypes.bool,
  recurrenceEndDate: PropTypes.string,
  recurrencePattern: PropTypes.string,
};
